import * as React from 'react';
import SelectField from '../../common/form-controls/SelectField';
import { PortOpeningRequestsDirection } from '../../../models/enums/POR/PortOpeningRequestsDirection';
import FieldHandler from '../../../models/interfaces/FieldHandler';

interface AWSPORScopeInputProps{
    direction: FieldHandler<string>
    type: string;
}

interface AWSPORScopeInputState { }

export class AWSPORScopeInput extends React.Component<AWSPORScopeInputProps, AWSPORScopeInputState> {

    scopeOptions = (typeName: string) => {
        const options = {
            AccountToInternet: [
                { value: PortOpeningRequestsDirection.TrustedToInternet.name, text: PortOpeningRequestsDirection.TrustedToInternet.displayName }
            ],
            AccountToDMZ: [
                { value: PortOpeningRequestsDirection.InternetToDMZNorth.name, text: PortOpeningRequestsDirection.InternetToDMZNorth.displayName },
                { value: PortOpeningRequestsDirection.DMZTrustedToL4South.name, text: PortOpeningRequestsDirection.DMZTrustedToL4South.displayName },
                { value: PortOpeningRequestsDirection.DMZToInternetSouthObi.name, text: PortOpeningRequestsDirection.DMZToInternetSouthObi.displayName }
            ],
            Untrusted: [
                { value: PortOpeningRequestsDirection.GLLOnPremToGLLAWS.name, text: PortOpeningRequestsDirection.GLLOnPremToGLLAWS.displayName },
                { value: PortOpeningRequestsDirection.GLLAWSToGLLAWS.name, text: PortOpeningRequestsDirection.GLLAWSToGLLAWS.displayName },
                { value: PortOpeningRequestsDirection.GLLAWSToGLUizL4.name, text: PortOpeningRequestsDirection.GLLAWSToGLUizL4.displayName },
                { value: PortOpeningRequestsDirection.UntrustedToL4.name, text: PortOpeningRequestsDirection.UntrustedToL4.displayName },
                { value: PortOpeningRequestsDirection.UntrustedToInternet.name, text: PortOpeningRequestsDirection.UntrustedToInternet.displayName },
                { value: PortOpeningRequestsDirection.ExternalAccounts.name, text: PortOpeningRequestsDirection.ExternalAccounts.displayName }
            ]
        }

        return typeName == '' || typeName == undefined ? [] : options[typeName]
    };
    
    render() {
        return (
            <SelectField
                label="Scope"
                className="full-width"
                options={this.scopeOptions(this.props.type)}
                {...this.props.direction}
            />
        );
    }
}
